import axios from 'axios'
/**
 * api calls die ohne token funktionieren...
 */
export default {
  async execute (method, resource, data) {
    return axios({
      method,
      url: resource,
      data
    }).then(req => {
      return req.data
    })
  },
  // neuen Auftrag anlegen
  createAuftrag (data) {
    return this.execute('post', '/api/ws/createAuftrag', data)
  },
  // return the skills list
  skillList () {
    return this.execute('get', '/api/basic/skillList')
  },
  // return the format list
  formatList () {
    return this.execute('get', '/api/basic/formatList')
  }
}



// WEBPACK FOOTER //
// ./src/main/vue/api/public.js